module.exports = __webpack_public_path__ + "img/Menu-04.d6aa5b16.webp";